module.exports = __webpack_public_path__ + "img/DNADamage-BRCA_10X_DCIS.5dd4e8bf.png";